/**
 * Module dependencies.
 */

import React from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { InputFormItem } from '../form-types';
import { TimePickerField } from 'app/components/atoms/forms/fields/date-picker/time-picker-field';

/**
 * `Props` type.
 */

type Props = {
  name: string;
  item: InputFormItem;
  form: UseFormReturn<FieldValues, any>;
};

/**
 * Export `FormTimePickerField` component.
 */

export function FormTimePickerField(props: Props): JSX.Element {
  const { form, item } = props;
  const { control } = form;
  const { name, placeholder, label, rules, disabled } = item;

  return (
    <TimePickerField
      control={control}
      disabled={disabled}
      label={label}
      name={name}
      placeholder={placeholder ?? placeholder === false ? undefined : label}
      rules={rules}
    />
  );
}
